module.exports = __webpack_public_path__ + "static/img/celoscope-detail-32.20e5f5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-32.jpg
// module id = ef8x
// module chunks = 51